import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouter} from 'next/router';
import productActions from '../../store/actions/productActions';
import IconSearch from '../UI/Icons/IconSearch';
import SearchResultList from './components/SearchResultList/SearchResultList';
import urlHelper from '../../helpers/url.helper';
import useDebounce from '../../customHooks/useDebounce';
import helpers from '../../helpers/helpers';
import cls from 'classnames';
import styles from './Search.module.scss';

const Search = ({categoryCallback, currentCategory}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const {getTranslationText} = helpers;

  const {foundProducts, searchIsLoading} = useSelector((state) => state.products);

  const [searchValue, setSearchValue] = useState('');
  const [isSearchResult, toggleSearchResult] = useState(false);
  const [showBlur, toggleShowBlur] = useState(false);

  const searchValueDebounced = useDebounce(searchValue, 500);

  //const closeLocationDropdown = (isDropdown) => toggleLocationDropdown(isDropdown);
  const closeSearchDropdown = (isDropdown) => {
    toggleSearchResult(
      foundProducts && !!foundProducts.length && isDropdown,
    );
  };
  const onFocusInputHandler = () => {
    if (router.asPath.split('?')[0] !== '/search') {
      toggleShowBlur(true);
      closeSearchDropdown(true);
    }
  };
  const closeBlurHandler = () => {
    toggleSearchResult(false);
    toggleShowBlur(false);
  };

  useEffect(() => {
    const query = urlHelper.searchAsObject(router.asPath.split('?')[1]);
    if (query.query && !searchValue) {
      setSearchValue(router.query.query);
    }
    if (!query.query && searchValue) {
      setSearchValue('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  useEffect(() => {
    if (searchValueDebounced !== '' && searchValueDebounced?.length > 2) {
      router.replace(router.route, urlHelper.buildUrl(router, {
        query: searchValueDebounced,
      }));
      const params = {
        search: searchValueDebounced,
        include: 'photos,categories',
        searchFields: 'title;link;tag;city;region;country;username',
      };
      if (categoryCallback) {
        categoryCallback(params);
      } else {
        dispatch(productActions.getSearchAllProducts(params));
      }
    } else if (categoryCallback && searchValueDebounced === '') {
      categoryCallback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValueDebounced]);

  useEffect(() => {
    if (router.asPath.split('?')[0] !== '/search') {
      toggleSearchResult(foundProducts && !!foundProducts.length && searchValueDebounced !== '');
    }
  }, [foundProducts, searchValueDebounced]);

  useEffect(() => {
    if (searchIsLoading && router.asPath.split('?')[0] !== '/search') {
      toggleSearchResult(true);
    }
  }, [searchIsLoading]);

  const inputKeyPressHandler = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      router.push(`/search?query=${searchValue}`, `/search?query=${searchValue}`, {shallow: true, locale: router.locale});
    }
  };

  return (
    <div className={cls(styles.search, {[styles.active]: showBlur})}>
      <div className={styles.searchInner}>
        <form className={styles.searchField} autoComplete="off">
          <IconSearch/>
          <input
            type="text"
            autoComplete="off"
            placeholder={currentCategory
              ? `${getTranslationText('search.by_category')} ${currentCategory}`
              : getTranslationText('search.search')}
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            onKeyDown={inputKeyPressHandler}
            onFocus={onFocusInputHandler}
          />
        </form>
        <SearchResultList
          isVisible={isSearchResult}
          foundProducts={foundProducts}
          searchValue={searchValue}
          closeDropdown={closeSearchDropdown}
          searchIsLoading={searchIsLoading}
        />
      </div>
      <div
        className={styles.searchBlur}
        onClick={closeBlurHandler}
      />
    </div>
  );
};

export default Search;
